/*
 * Http Interceptor to automatically add loading indicator on all http calls
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import {Observable,} from 'rxjs';
import {finalize, map} from 'rxjs/operators';
import {LoadingIndicatorService} from '../services';

@Injectable()
export class HttpLoadingInterceptor implements HttpInterceptor {

  constructor(
    private loadingIndicatorService: LoadingIndicatorService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingIndicatorService.setLoadingState(true);
    return next.handle(request)
      .pipe(
        map((event: HttpEvent<any>) => {
          if(event instanceof HttpResponse) {
            const executionTime = event.headers.get('x-execution-time') || '0';
            this.loadingIndicatorService.serverExecutionTime$.next(executionTime);
          }
          return event;
        }),
        finalize(() => {
          // Let's give it some time in case of sequenced requests
          setTimeout(() => {
            this.loadingIndicatorService.setLoadingState(false);
          }, 100);
        })
      );
  }
}
